import React from 'react';

import styled from '@emotion/styled';

import { Box, COLORS, Text } from '@clutter/clean';

const Container: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box.Grid
      gridTemplateColumns={[
        '1fr',
        '1fr 1fr',
        'repeat(3, 1fr)',
        'repeat(4, 1fr)',
      ]}
      gridGap="24px 32px"
    >
      {children}
    </Box.Grid>
  );
};

const StyledAnchor = styled.a({
  color: COLORS.tealPrimary,
  '&:hover': {
    color: COLORS.__primaryButtonHover,
  },
});

const Link: React.FC<{ to: string; children: React.ReactNode }> = ({
  to,
  children,
}) => {
  return (
    <Text.Button color={COLORS.tealPrimary} textDecoration="underline">
      <StyledAnchor href={to}>{children}</StyledAnchor>
    </Text.Button>
  );
};

export const LocationLinksLayout = Object.assign(Container, { Link });
